module.exports = __webpack_public_path__ + "static/media/lms-school-logo.4fc2a81a.png";